<template>
  <!-- 导航开始 -->
  <div class='commonClientcontract' :class="{appBool:appBool}">
    <div class="topBox">
      <div class="infoBox">
        <div class="aa">
          <div class="letBox" @click="showModel(info.data_id)">
            <span v-if="info.user">{{info.user.charAt(0)}}</span>
            <span v-else><i class="iconfont icon-jiazai xuanzhuan"></i></span>
            <i class="iconfont icon-icons_search"></i>
          </div>
          <div class="ritBox">
            <ul>
              <li>{{info.topic}}</li>
              <li>
                <span class="badge badge-light">合同编号：{{info.tokenid}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="cc">
          <span>状态：<i>{{info.isstatus_str}}</i></span>
          <span>付款：<i>{{info.moneytype_str}}</i></span>
        </div>
        <div class="cc">
          <span>金额：<i>{{info.money?info.money:'空...'}}</i></span>
          <span>录入：<i>{{info.adduid_user}}</i></span>
        </div>
        <div class="bb">
          <span>备注：<i>{{info.contents?info.contents:'空...'}}</i></span>
        </div>
      </div>
      <div class="menuBox">
        <span @click="qiehuanFun('ui-contract-info-trace')" :class="{active:isCompnentElement==='ui-contract-info-trace'}">跟进</span>
        <span @click="qiehuanFun('ui-contract-info-file')" :class="{active:isCompnentElement==='ui-contract-info-file'}">附件</span>
      </div>
    </div>
    <div class="mainBox">
      <component :rootContractUnitIsSuccessFun="rootContractUnitIsSuccessFun" :token="token" :is="isCompnentElement"></component>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import uiContractInfoTrace from '@/components/common/contractinfo/trace';
import uiContractInfoFile from '@/components/common/contractinfo/files';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'commonClientcontract',
  props: {
    token: {
      type: String,
      default: '',
    },
    appBool: {
      type: Boolean,
      default: false,
    },
    rootContractUnitIsSuccessFun: {
      type: Function,
      default() {
        return Function;
      },
    },
  },
  data() {
    return {
      info: {},
      isCompnentElement: 'ui-contract-info-trace',
    };
  },
  computed: {
  },
  methods: {
    showModel(id) {
      EventBus.$emit('globalRightBoxFun', { bool: true, compnent: 'ui-home-clientinfo', token: id });
    },
    qiehuanFun(str) {
      if (this.isCompnentElement !== str) {
        this.isCompnentElement = str;
      }
    },
  },
  components: {
    // 引入图片上传组件
    'ui-contract-info-file': uiContractInfoFile,
    'ui-contract-info-trace': uiContractInfoTrace,
  },
  created() {
    resultCommons.apiCrmPactInfo(this, { token: this.token }).then((app) => {
      this.info = app.data;
    });
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientcontract{
  box-shadow: 0 0 1rem rgba(0, 0, 0, .5);
  background: #F6F6F6;
  width: 85vw;
  max-width: 580px;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  //border-bottom-left-radius: 1rem;
  border-top-left-radius: 1rem;
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 0;
  margin-right: 0;
  position: relative;
  &.appBool{
    height: 100%;
    margin: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .topBox{
    background-image: linear-gradient(180deg, #D4DFFA 20%,#EEEFF6 80%);
    background: #D34836;
    color: #FFFFFF;
  }
  .infoBox{
    padding: 15px;
    div.aa{
      display: flex;
      flex-direction: row;
      margin-bottom: 15px;
      div.letBox{
        width: 65px;
        height: 65px;
        background: #FFFFFF;
        margin-right: 20px;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'gilroy-semibold';
        font-size: 26px;
        border-radius: 1rem;
        border:2px solid rgba(0,0,0,0);
        position: relative;
        cursor: pointer;
        color: #2937FD;
        i{
          position: absolute;
          right: 0px;
          bottom: 0px;
        }
      }
      div.ritBox{
        flex: 1;
        display: flex;
        align-items: center;
        ul{
          li{
            &:first-child{
              font-size: 18px;
              margin-bottom: 10px;
            }
            .badge{
              margin-right: 0;
              font-size: 12px;
              font-weight: 300;
              margin-left: 0;
              &:last-child{
                margin: 0;
              }
            }
            &.tow{
              span{
                display: inline-block;
                i{
                  color: #999999;
                  font-style: normal;
                }
              }
            }
          }
        }
      }
    }
    div.cc{
      display: flex;
      //border-top:1px solid rgba(0,0,0,0.08);
      //margin-top: 10px;
      //padding-top: 15px;
      span{
        display: inline-block;
        margin-right: 0;
        flex: 1;
        color: rgba(255,255,255,0.5);
        line-height: 2em;
        i{
          font-style: normal;
          color: #FFFFFF;
        }
        &:last-child{
          margin: 0;
        }
      }
    }
    div.bb{
      margin-top: 10px;
      span{
        flex: 1;
        color: rgba(255,255,255,0.5);
        i{
          font-style: normal;
          color: rgba(255,255,255,0.6);
        }
      }
    }
  }
  .menuBox{
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    //color: #FFFFFF;
    span{
      flex: 1;
      display: inline-block;
      text-align: center;
      color: rgba(255,255,255,0.5);
      line-height: 2em;
      cursor:pointer;
      letter-spacing: 3px;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      &:hover{
        background: rgba(0,0,0,0.1);
      }
      &.active{
        background: rgba(0,0,0,0.2);
        color: #FFFFFF;
      }
      &:last-child{
        margin: 0;
      }
    }
  }
  .mainBox{
    flex: 1;
    display: flex;
    overflow:hidden;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/contractinfo/info.vue